<div class="listing-details-wrapper">
  <ion-progress-bar [value]="completePercent / 100" class="divider-line" style="height: 3px"></ion-progress-bar>
  <div class="listing-icon icon-boondock">
    <div class="w-embed" style="width: 100%">
      <curbnturf-map-icons type="boondockPinLarge" [primary]="true"> </curbnturf-map-icons>
    </div>
    <curbnturf-checked *ngIf="poi.available"></curbnturf-checked>
  </div>
  <img
    [src]="photoUrl"
    [alt]="poi?.photos[0]?.caption || 'POI Image for ' + poi?.name"
    loading="lazy"
    width="380"
    class="listing-info-image"
  />
  <div class="listing-info-description">
    <div class="listing-name-header">
      <h3 [innerHtml]="poi?.name"></h3>
    </div>
  </div>
  <div class="listing-options-inner">
    <a (click)="openPoiEditModal()" class="cnt-button w-button"> Edit </a>
    <a (click)="openPoiViewModal()" class="cnt-button w-button"> View </a>

    <ng-template #poiDeleteTemplate>
      <button type="button" class="delete-button cnt-button">
        <span class="cnt-button-icon">
          <curbnturf-misc-svg icon="new-trash" class="normal"> </curbnturf-misc-svg>
          <curbnturf-misc-svg icon="new-trash" color="#fff" class="hovered"> </curbnturf-misc-svg>
        </span>
        <span class="cnt-button-copy">Delete</span>
      </button>
    </ng-template>
    <curbnturf-delete-confirmation-modal
      [name]="poi?.name"
      [template]="poiDeleteTemplate"
      [deleteFunction]="removePoiFunction(poi?.id ?? poi?.syncId)"
    >
    </curbnturf-delete-confirmation-modal>
  </div>
</div>
